
import { Vue, Component } from 'vue-property-decorator';
import {
  Form,
  FormItem,
  Input,
  Cascader,
  Select,
  Option,
} from 'element-ui';
import apis from '@/api/exam';
import app from '@/api/app';
import { COMMON_DATA_TYPE } from '@/libs/config';

@Component({
  components: {
    Form,
    FormItem,
    Input,
    Cascader,
    Select,
    Option,
  },
})

export default class SearchForm extends Vue {
  private form: any = {
    knowledge: '',
    subjectId: '',
    type: '',
    serial: '',
  };

  public $refs!: {
    form: Form,
  };

  private quesBank: any = [];

  private knowledges: any = [];

  private question: any = [];

  mounted() {
    // 获取题库
    apis.getAllQuesBank().then((res: any) => {
      // this.quesBank = res;
      this.quesBank = res.filter((item:any) => item.status !== 1);
    });
    app.getBaseDataByType([COMMON_DATA_TYPE.KNOWLEDGE, COMMON_DATA_TYPE.QUESTION]).then((res: any) => {
      // 获取知识点
      this.knowledges = res.knowledge;
      // 获取试题类型
      this.question = res.question;
    });
  }

  setTitle(val: string) {
    this.form.serial = val;
  }

  getFormData() {
    return {
      subjectId: this.form.subjectId,
      knowledge: this.form.knowledge,
      type: this.form.type,
      serial: this.form.serial,
    };
  }

  /**
   * @author liangyongmou
   * @desc 清空事件
   */
  handleClear() {
    this.$refs.form.resetFields();
  }
}
